// extracted by mini-css-extract-plugin
module.exports = {"description":"QuotazioneGaranziaHomeBoxForm_description__Pff5F","list":"QuotazioneGaranziaHomeBoxForm_list__E0Idu"};